



















































































































































































































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { PaginationPanel, HoriScroll } from '@/components';
import collapse from '../../utils/collapse.js';
import publicFunc from '../../common/util/publicFunc';
import { Yuyue, Inquiry, Dock } from '@/http';
import { type } from '@/http/interface';
import { enums } from '@/common/enums';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import validator, { formRules } from '@/common/util/validator';

export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        PaginationPanel,
        collapse,
        ListFilterPanel,
        HoriScroll,
    },
})
export default class ReceiptManage extends Vue {
    public $refs: {
        date: HTMLFormElement;
    };
    public form: any = {
        number: '',
        status: '',
        dock: '',
        driverName: '',
        driverPhone: '',
        appointmentTime: '',
        wareHouse: '',
        goodsList: [],
        projectCode: '',
    };
    public searchValue = {
        wareHouseId: '',
    };
    public formRules = formRules;
    public optionSingleHeightTime = {
        isSingleRemUnit: true,
        singleHeight: 2.5, //单行停顿间距
        waitTime: 3000, //单行停顿时间
        limitMoveNum: 10,
    };
    public year: any = '';
    public month: any = '';
    public date: any = '';
    public hour: any = '';
    public minute: any = '';
    public second: any = '';

    public isFullscreen: any = false;
    public detailDialog: any = false;
    handleDetailClose() {
        this.detailDialog = false;
    }
    public async rowClick(item) {
        // let res = await this.$service.GetOrderDetail(item.id)
        // this.form = res;
        // console.log('resssss->',res,item);
        // let yts = await this.$service.getDockDropDown({'wareHouseId':res.wareHouseId});
        // this.yts = yts.map(v=>{return {
        //     name:v.name,
        //     id:v.id
        // }})
        // this.ytds = res.dockeIds?res.dockeIds.split(','):[];
        let res = await Yuyue.getYyDetail(item.id);
        this.form = { ...res };
        this.total = this.form.goodsList ? this.form.goodsList.length : 0;
        this.detailDialog = true;
        //item.isactive = !item.isactive;
        console.log('row click-->', item, res);
    }
    public callDialgForm: any = {
        id: '',
        yt: '',
        jhz: false,
    };
    public callDialog: any = false;
    handlecallClose() {
        this.callDialog = false;
    }
    docks: any = [];
    //叫号
    public async call(row) {
        //console.log('row-->',row,this.searchValue.wareHouseId);
        this.callDialog = true;
        if (this.$refs['callForm']) {
            (this.$refs['callForm'] as any).resetFields();
        }
        //当前仓库月台个数
        let res = await Dock.GetDockList({
            wareHouseId: this.searchValue.wareHouseId,
            isEnabled: true,
            skip: 0,
            count: -1,
        });
        console.log('docks-->', res);
        this.docks = res.data;
        this.callDialgForm.jhz = false;
        this.callDialgForm.yt = '';
        //当前仓库月台个数

        if (this.docks && this.docks.length == 1) {
            this.callDialgForm.id = row.id;
            this.callDialgForm.yt = this.docks[0].id;
        }
        if (this.docks && this.docks.length > 1) {
            this.callDialgForm.id = row.id;
            this.callDialgForm.yt = '';
        }

        // if(this.docks.length>1){
        //     this.callDialog = true;
        //     this.callDialgForm.id = row.id;
        //     this.callDialgForm.yt ="";
        //     if(this.$refs['callForm']){
        //         //console.log('reeee-->',this.$refs['callForm']);
        //         (this.$refs['callForm'] as any).resetFields();
        //     }
        // }else{
        //     let h = this.$createElement
        //     this.$confirm('',{
        //         message:h('div',null, [
        //         h('span',{ style:'margin-left:10px;font-size:16px;line-height:30px;font-weight:600;vertical-align:top;'}, [
        //             h('i',{ class:'iconfont icon-lingdang-xianxing',style:'color:#64a6ff;font-size:20px;margin-right:10px;' }),
        //             h('span',null,'确认叫号'),
        //         ]),
        //         h('p',{ style:'margin:10px 0 0 40px;' },[
        //             h('span',null,'是否确认'),
        //             h('span',{style:'color:#64a6ff'},'叫号'),
        //             h('span',null,'?')
        //         ])
        //     ]),
        //     }).then(res=>{
        //         Yuyue.call({id:row.id,dockId:this.docks[0].id}).then(res=>{
        //             this.$message.success('叫号成功!');
        //             this.handleSearch(this.searchValue.wareHouseId);
        //         })
        //     })
        // }
    }
    public selectRow: any = '';
    //排队中叫号
    public async pdzcall(row) {
        this.selectRow = row;
        this.callDialog = true;
        if (this.$refs['callForm']) {
            (this.$refs['callForm'] as any).resetFields();
        }

        //当前仓库月台个数
        let res = await Dock.GetDockList({
            wareHouseId: this.searchValue.wareHouseId,
            isEnabled: true,
            skip: 0,
            count: -1,
        });

        this.docks = res.data;
        this.callDialgForm.jhz = true;

        // this.callDialgForm.yt = '';
        // this.callDialgForm.id = '';
        //当前仓库月台个数

        if (this.docks && this.docks.length == 1) {
            this.callDialgForm.id = row.id;
            //this.callDialgForm.yt =this.docks[0].id;
            this.$set(this.callDialgForm, 'yt', this.docks[0].id);
            console.log('yige');
        } else if (this.docks && this.docks.length > 1) {
            this.callDialgForm.id = row.id;
            this.callDialgForm.yt = '';
            console.log('duoge');
        } else {
            //this.callDialgForm.yt = '';
            this.callDialgForm.id = '';
            this.$set(this.callDialgForm, 'yt', '');
            console.log('else');
        }
        console.log('docks-->', res, this.docks.length, this.callDialgForm);

        // if(this.docks.length>1){
        //     this.callDialog = true;
        //     this.callDialgForm.id = row.id;
        //     this.callDialgForm.yt ="";
        //     (this.$refs['callForm'] as any).resetFields();
        // }else{
        //     let h = this.$createElement
        //     this.$confirm('',{
        //         message:h('div',null, [
        //         h('span',{ style:'margin-left:10px;font-size:16px;line-height:30px;font-weight:600;vertical-align:top;'}, [
        //             h('i',{ class:'iconfont icon-lingdang-xianxing',style:'color:#64a6ff;font-size:20px;margin-right:10px;' }),
        //             h('span',null,'确认叫号'),
        //         ]),
        //         h('p',{ style:'margin:10px 0 0 40px;' },[
        //             h('span',null,'是否确认'),
        //             h('span',{style:'color:#64a6ff'},'叫号'),
        //             h('span',null,'?')
        //         ])
        //     ]),
        //     }).then(res=>{
        //         Yuyue.call({id:row.id,dockId:this.docks[0].id}).then(res=>{
        //             this.$message.success('叫号成功!');
        //             this.countCode(row);
        //             //this.handleSearch(this.searchValue.wareHouseId);
        //         })
        //     })
        // }
    }
    /**
     * 倒计时
     */
    countCode(row) {
        //this.disYzm = true;
        //this.countDowning = true;
        row.seconds = '60秒';
        let i = 60;
        row.interval = setInterval(() => {
            row.seconds = `${--i}秒`;
            if (i === 0) {
                clearInterval(row.interval);
                row.seconds = '叫号';
                //this.btnMessage = '获取验证码';
                // this.disYzm = false;
                // this.isSend = false;
                // this.countDowning = false;
            }
        }, 1000);
    }
    public calld() {
        this.$refs['callForm']['validate']((valid) => {
            if (valid) {
                this.callDialog = false;
                if (this.callDialgForm.jhz) {
                    this.countCode(this.selectRow);
                    let val = this.docks.filter((v) => {
                        return v.id == this.callDialgForm.yt;
                    });
                    let dockName = val && val.length > 0 ? val[0].name : '';
                    console.log('叫号中-->', this.selectRow, val, dockName, this.pdzData);
                    // for(let i=0;i<this.pdzList.length;i++){
                    //     for(let j=0;j<this.pdzList[i].length;j++){
                    //         if(this.pdzList[i][j].id == this.selectRow.id){

                    //             this.pdzList[i][j].dock = dockName
                    //                 console.log('find-->',dockName,this.pdzList[i][j]);
                    //                 break;
                    //         }
                    //     }
                    // }
                    for (let i = 0; i < this.pdzData.length; i++) {
                        if (this.pdzData[i].id == this.selectRow.id) {
                            this.pdzData[i].dock = dockName;
                            console.log('find-->', dockName, this.pdzData[i]);
                            break;
                        }
                    }
                }
                Yuyue.call({ id: this.callDialgForm.id, dockId: this.callDialgForm.yt }).then((res) => {
                    this.$message.success('叫号成功!');

                    if (!this.callDialgForm.jhz) {
                        this.handleSearch(this.searchValue.wareHouseId);
                    }
                });
            }
        });
    }
    public dialogConfig = {
        title: '',
        show: false,
    }
    confirmClose() {
        this.dialogConfig = {
         title: '',
         show: false,
        };
    }
    // 出厂
     public dialogConfig1 = {
        title: '',
        show: false,
    }
    confirmClose1() {
        this.dialogConfig1 = {
         title: '',
         show: false,
        };
    }
    // 一键出厂
     public dialogConfig2 = {
        title: '',
        show: false,
    }
    confirmClose2() {
        this.dialogConfig2 = {
         title: '',
         show: false,
        };
    }
    confirmOk(){
        if(this.row1){
            Yuyue.bePresent(this.row1).then((res) => {
                this.$message.success('确认到厂成功!');
                this.handleSearch(this.searchValue.wareHouseId);
            });
        }
        else if(this.row2){
            Yuyue.pass(this.row2).then((res) => {
                this.$message.success('确认过号成功!');
                this.handleSearch(this.searchValue.wareHouseId);
            });
        }
       
        this.dialogConfig = {
            title:'',
            show:false
        }
    }
    confirmOk1(){
          if(this.row3){
            Yuyue.leavePresent(this.row3).then((res) => {
                this.$message.success('确认出厂成功!');
                this.handleSearch(this.searchValue.wareHouseId);
        });
      }
       this.dialogConfig1 = {
            title:'',
            show:false
        }
    }
    confirmOk2(){        
            Yuyue.yjLeavePresent(this.searchValue.wareHouseId).then((res) => {
                this.$message.success('一键出厂成功!');
                this.handleSearch(this.searchValue.wareHouseId);
            });
            this.dialogConfig2 = {
            title:'',
            show:false
        }
        
    }
    //到厂
    public row1:string = ''
    public daochang(row) {
        this.row1 = row.id
        this.dialogConfig = {
         title: '到厂',
         show: true,
        };
        // let h = this.$createElement;
        // this.$confirm('', {
        //     //title:'确认到厂',
        //     //message:'是否确认到厂?',
        //     message: h('div', null, [
        //         h('span', { style: 'margin-left:10px;font-size:16px;line-height:30px;font-weight:600;vertical-align:top;' }, [
        //             h('i', { class: 'iconfont icon-chuchang', style: 'color:#64a6ff;font-size:20px;margin-right:10px;' }),
        //             h('span', null, '确认到厂'),
        //         ]),
        //         h('p', { style: 'margin:10px 0 0 40px;' }, [
        //             h('span', null, '是否确认'),
        //             h('span', { style: 'color:#64a6ff' }, '到厂'),
        //             h('span', null, '?'),
        //         ]),
        //     ]),
        //     //iconClass:'iconfont icon-ico_yuyueguanli_jiedaiyuyue'
        // }).then((res) => {
        //     Yuyue.bePresent(row.id).then((res) => {
        //         this.$message.success('确认到厂成功!');
        //         this.handleSearch(this.searchValue.wareHouseId);
        //     });
        // });
    }
    //过号
    public row2:string =''
    public guohao(row) {
        this.row2 = row.id
         this.dialogConfig = {
         title: '过号',
         show: true,
        };
        // let h = this.$createElement;
        // this.$confirm('', {
        //     message: h('div', null, [
        //         h('span', { style: 'margin-left:10px;font-size:16px;line-height:30px;font-weight:600;vertical-align:top;' }, [
        //             h('i', { class: 'iconfont icon-guohao', style: 'color:#fc8d70;font-size:20px;margin-right:10px;' }),
        //             h('span', null, '确认过号'),
        //         ]),
        //         h('p', { style: 'margin:10px 0 0 40px;' }, [
        //             h('span', null, '是否确认'),
        //             h('span', { style: 'color:#fc8d70' }, '过号'),
        //             h('span', null, '?'),
        //         ]),
        //     ]),
        // }).then((res) => {
        //     Yuyue.pass(row.id).then((res) => {
        //         this.$message.success('确认过号成功!');
        //         this.handleSearch(this.searchValue.wareHouseId);
        //     });
        // });
    }
    //出厂
    public row3:string =''
    public chuchang(row) {
      this.row3 = row.id
      this.dialogConfig1 = {
         title: '出厂',
         show: true,
        };
        // let h = this.$createElement;
        // this.$confirm('', {
        //     message: h('div', null, [
        //         h('span', { style: 'margin-left:10px;font-size:16px;line-height:30px;font-weight:600;vertical-align:top;' }, [
        //             h('i', { class: 'iconfont icon-chuchang', style: 'color:#ffa44c;font-size:20px;margin-right:10px;' }),
        //             h('span', null, '确认出厂'),
        //         ]),
        //         h('p', { style: 'margin:10px 0 0 40px;' }, [
        //             h('span', null, '是否确认'),
        //             h('span', { style: 'color:#ffa44c' }, '出厂'),
        //             h('span', null, '?'),
        //         ]),
        //     ]),
        // }).then((res) => {
        //     Yuyue.leavePresent(row.id).then((res) => {
        //         this.$message.success('确认出厂成功!');
        //         this.handleSearch(this.searchValue.wareHouseId);
        //     });
        // });
    }
    // 一键出厂
    public yjcc() {
         this.dialogConfig2 = {
         title: '一键出厂',
         show: true,
        };
        // let h = this.$createElement;
        // this.$confirm('', {
        //     message: h('div', null, [
        //         h('span', { style: 'margin-left:10px;font-size:16px;line-height:30px;font-weight:600;vertical-align:top;' }, [
        //             h('i', { class: 'iconfont icon-yijiancuibao', style: 'color:#ffa44c;font-size:20px;margin-right:10px;' }),
        //             h('span', null, '确认一键出厂'),
        //         ]),
        //         h('p', { style: 'margin:10px 0 0 40px;' }, [
        //             h('span', null, '是否确认'),
        //             h('span', { style: 'color:#ffa44c' }, '一键出厂'),
        //             h('span', null, '?'),
        //         ]),
        //     ]),
        // }).then((res) => {
        //     Yuyue.yjLeavePresent(this.searchValue.wareHouseId).then((res) => {
        //         this.$message.success('一键出厂成功!');
        //         this.handleSearch(this.searchValue.wareHouseId);
        //     });
        // });
    }
    screenFull() {
        // if(!screenfull.enabled){
        //     this.$message({
        //     message:'浏览器不支持',
        //     type:'warning'
        //     })
        //     return false
        // }
        // console.log(screenfull);
        // this.isFullscreen=screenfull.isFullscreen;
        // screenfull.toggle();
    }
    // @Watch('isFullscreen')
    // screenChange(val){
    //     console.log('this.isFullscreen',this.isFullscreen);
    //     if(val){
    //         console.log('全屏了');
    //     }else{
    //         console.log('非全屏了');
    //     }
    // }
    checkFull() {
        // let isFull=document.fullscreenEnabled||window.fullScreen||document.webkitIsFullScreen||document.msFullscreenEnabled;
        // console.log('checkFull',isFull);
        // if(isFull===undefined){
        // isFull=false;
        // }
        // return isFull;
    }
    keydown(event) {
        if (event.keyCode === 122) {
            event.preventDefault();
            event.returnValue = false;
        }
    }
    onresize(event) {
        let winFlag = window.innerHeight === window.screen.height;
        //   let isFull = window.fullScreen || document.webkitIsFullScreen

        //   if (isFull === undefined) {
        //     this.isFullscreen = winFlag
        //   } else {
        //     this.isFullscreen = winFlag || isFull
        //   }
    }
    created() {
        // window.addEventListener('resize', this.onresize)
        // window.addEventListener('keydown', this.keydown)
    }
    public pdzData: any = [];
    public jhzData: any = [];
    public zxzData: any = [];
    mounted() {
        this.initCk();
        // setInterval(()=>{
        //     let now=new Date();
        //     this.year=now.getFullYear()+"";
        //     this.month=(now.getMonth()+1).toString();
        //     this.date=now.getDate()+'';
        //     this.hour=now.getHours()+'';
        //     this.minute=now.getMinutes()<10?'0'+now.getMinutes():now.getMinutes()+'';
        //     this.second=now.getSeconds()<10?'0'+now.getSeconds():now.getSeconds()+'';

        // },1000);
    }
    beforeDestroy() {
        //   window.removeEventListener('resize', this.onresize)
        //   window.removeEventListener('keydown', this.keydown)
        this.clearIntervals();
        this.closeroll();
    }
    clearIntervals() {
        if (this.pdzData && this.pdzData.length > 0) {
            console.log('排队列表');
            // for(let i =0;i<this.pdzList.length;i++){
            //     for(let j=0;j<this.pdzList[i].length;j++){
            //         if(this.pdzList[i][j].interval){
            //             clearInterval(this.pdzList[i][j].interval);
            //             this.pdzList[i][j].interval = null;
            //             console.log('关闭了-》',i);
            //         }else{
            //             console.log('为空');
            //         }
            //     }
            //     //console.log('interval-->',this.pdzList,this.pdzList[i].interval);
            // }
            for (let i = 0; i < this.pdzData.length; i++) {
                if (this.pdzData[i].interval) {
                    clearInterval(this.pdzData[i].interval);
                    this.pdzData[i].interval = null;
                    console.log('关闭了-》', i);
                } else {
                    console.log('为空');
                }
            }
        }
    }
    public cks: any = [];
    public tempReservedList: any = [];
    async initCk() {
        this.cks = [];
        let uid = JSON.parse(sessionStorage.getItem('id') ? sessionStorage.getItem('id') : JSON.parse(localStorage.getItem('mlssloginAd')).id);
        let res = await Yuyue.GetWareHouseList({ name: '', keeperName: '', keeperId: uid, enabled: true, skip: 0, count: -1 });
        res.data.forEach((e) => {
            this.cks.push({ value: e.name, id: e.id });
        });
        console.log('res', res, this.cks);
        if (!this.searchValue.wareHouseId) {
            this.searchValue.wareHouseId = this.cks && this.cks.length > 0 ? this.cks[0].id : '';
            console.log('[enter', this.searchValue.wareHouseId, this.cks[0]);
        }
        this.handleSearch(this.searchValue.wareHouseId);
        // this.form.calledList = this.orderList;
        // for (var i = 0; i < this.form.calledList.length; i += 10) {
        //     this.tempReservedList.push(this.form.calledList.slice(i, i + 10));
        // }
        console.log('ffffffffff', this.tempReservedList);
    }
    public yyData: any = [];
    public yyyList: any = [];
    public pdzList: any = [];
    public jhzList: any = [];
    public yyyTotal: any = 0;
    public pdzTotal: any = 0;
    public jhzTotal: any = 0;
    public tips: any = '';
    async warehouseChange(id) {
        await this.handleSearch(id);
    }
    async handleSearch(id) {
        if (!id) {
            //this.$message.warning('请先选择仓库!');
            return;
        }
        this.clearIntervals();
        this.closeroll();
        console.log('chognxinget');
        this.yyyList = [];
        this.pdzList = [];
        this.jhzList = [];
        this.yyyTotal = 0;
        this.pdzTotal = 0;
        this.jhzTotal = 0;
        //3 排队中 4叫号中 6装卸中
        Yuyue.GetBoradDatas({
            wareHouseId: id,
            status: 3,
            skip: 0,
            count: -1,
        }).then((res) => {
            console.log('res', res);
            this.yyData = res.data.map((v) => {
                return { ...v, seconds: '叫号' };
            });
            this.yyyTotal = res.total;
            // for (var i = 0; i < this.yyData.length; i += 10) {
            //     this.yyyList.push(this.yyData.slice(i, i + 10));
            // }
        });
        Yuyue.GetBoradDatas({
            wareHouseId: id,
            status: 4,
            skip: 0,
            count: -1,
        }).then((res) => {
            this.pdzData = res.data.map((v) => {
                return { ...v, seconds: '叫号', interval: null };
            });
            this.pdzTotal = res.total;
            // for (var i = 0; i < this.pdzData.length; i += 10) {
            //     this.pdzList.push(this.pdzData.slice(i, i + 10));
            // }
        });
        Yuyue.GetBoradDatas({
            wareHouseId: id,
            status: 6,
            skip: 0,
            count: -1,
        }).then((res) => {
            this.jhzData = res.data;
            this.jhzTotal = res.total;
            // for (var i = 0; i < this.jhzData.length; i += 10) {
            //     this.jhzList.push(this.jhzData.slice(i, i + 10));
            // }
        });
        Yuyue.getTips(id).then((res) => {
            this.tips = res.extData;
            // if(id == 30){
            //     this.tips = '33333333333333333333333333333333333333333333333333333333333333335555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555'
            // }
            console.log('tips-->', res);
        });
        console.log('handlesearch', id, this.form);
        this.rollquery();
    }
    interval: any = null;
    rollquery() {
        this.interval = setInterval(this.gettips, 10000);
    }
    gettips() {
        if (this.searchValue.wareHouseId) {
            Yuyue.getTips(this.searchValue.wareHouseId).then((res) => {
                this.tips = res.extData;
                //this.tips = new Date().getTime()+'5555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555'
                console.log('tips-->', res);
            });
        }
    }
    closeroll() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }
    hasAuth(auth) {
        var authlist = sessionStorage.getItem('permissions') ? sessionStorage.getItem('permissions').split(',') : [];
        if (authlist.includes(auth)) {
            return true;
        } else {
            this.$message.warning('没有权限访问');
            return false;
        }
    }
    get sycount() {
        return this.$store.state.rongCloud.causeAuditCount;
    }
    get ylcount() {
        return this.$store.state.rongCloud.advanceAuditCount;
    }
    get bxcount() {
        return this.$store.state.rongCloud.reimburseAuditCount;
    }

    public pickerOptions: any = {
        shortcuts: [
            {
                text: '今天',
                onClick(picker) {
                    picker.$emit('pick', new Date());
                },
            },
            {
                text: '明天',
                onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() + 3600 * 1000 * 24);
                    picker.$emit('pick', date);
                },
            },
            {
                text: '后天',
                onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() + 3600 * 1000 * 24 * 2);
                    picker.$emit('pick', date);
                },
            },
        ],
    };
    public pageSizes = [10];
    public pageSize: number = 10;
    public total = 0;
    public paginationOptions = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public firstPageBtnDisabled = true;
    public lastPageBtnDisabled = false;
    public handleCurrentChange(val) {
        console.log('onPaginationChange', val);
        this.firstPageBtnDisabled = val === 1 ? true : false;
        this.lastPageBtnDisabled = val === Math.ceil(this.total / this.paginationOptions.count) ? true : false;
        this.paginationOptions.currentPage = val;
        this.paginationOptions.skip = (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
        console.log('this.paginationOptions~', this.paginationOptions);
    }
    public handleSizeChange(val) {
        console.log('handleSizeChangeval' + JSON.stringify(val));

        this.paginationOptions.count = val;
        this.paginationOptions.currentPage = 1;
        this.handleCurrentChange(this.paginationOptions.currentPage);
        if (Math.ceil(this.total / val) < this.paginationOptions.currentPage) {
            this.paginationOptions.skip = 0;
        } else {
            this.paginationOptions.skip = (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
        }
    }
}
